import { useState, useEffect } from "react";
import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";
import { ChevronDown, ChevronUp, ShieldAlert } from "lucide-react";
import { api } from "../../lib/api";
import { SEVERITY_STYLES } from "./projectUtils";

export function ImportIncidentsPanel({ token }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.getRdImportIncidents(token).then(setData).catch(() => setData(null));
  }, [token]);

  if (!data || !data.incidents?.length) return null;

  return (
    <Card data-testid="import-incidents-panel" className="border-amber-200 dark:border-amber-900">
      <CardContent className="pt-4">
        <button
          className="flex items-center justify-between w-full text-left"
          onClick={() => setOpen(!open)}
          data-testid="import-incidents-toggle"
        >
          <div className="flex items-center gap-2">
            <ShieldAlert className="w-4 h-4 text-amber-600" />
            <span className="font-medium text-sm">
              Incidencias de importación de datos ({data.incidents.length})
            </span>
            <span className="text-xs text-muted-foreground">
              · Fuente: {data.source_filename} · reconciliado {data.reconciled_at}
            </span>
          </div>
          {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </button>
        {open && (
          <div className="mt-4 space-y-2">
            {data.incidents.map((inc) => (
              <div
                key={inc.issue_code}
                className="p-3 rounded-lg border text-sm"
                data-testid={`incident-${inc.issue_code}`}
              >
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <Badge variant="outline" className={SEVERITY_STYLES[inc.severity] || ""}>
                    {inc.severity}
                  </Badge>
                  {inc.project_name && <Badge variant="secondary">{inc.project_name}</Badge>}
                  <span className="text-xs font-mono text-muted-foreground">{inc.issue_code}</span>
                </div>
                <p className="text-muted-foreground">{inc.description}</p>
                {inc.recommended_action && (
                  <p className="text-xs mt-1 italic text-muted-foreground/80">→ {inc.recommended_action}</p>
                )}
              </div>
            ))}
            <p className="text-xs text-muted-foreground pt-1">
              Hash de origen: <span className="font-mono">{data.source_sha256?.slice(0, 16)}…</span> — estas incidencias se conservan intencionadamente y no se ocultan ni se fuerzan a cero.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
